/**
 * Uzbek strings for the sign-in, Telegram, profile and password screens that have no
 * key in `i18n/uz.ts` yet. Kept in one place so they can move into the dictionary as a
 * block; keys that already exist there are read through `t()` at the call site instead.
 */
export const AUTH_MESSAGES = {
  orDivider: "yoki",
  telegramButton: "Telegram",
  googleButton: "Google",
  telegramNotLinked: "Bu Telegram akkaunt hech bir xodimga ulanmagan — Profil → Telegram'dan ulang",
  telegramDeclined: "Telegram orqali kirish bekor qilindi",
  telegramUnconfigured: "Telegram orqali kirish hozircha sozlanmagan.",
  telegramRefused: "Telegram orqali kirishni tasdiqlab bo'lmadi.",
  telegramConnectRefused: "Telegram ma'lumotini tasdiqlab bo'lmadi.",

  forgotTitle: "Parolni tiklash",
  forgotSubmit: "Havola yuborish",
  forgotSubmitting: "Yuborilmoqda…",
  resetTitle: "Yangi parol",
  resetSubmit: "Parolni yangilash",
  resetSubmitting: "Saqlanmoqda…",
  resetRequestNewLink: "Yangi havola so'rash",

  profileTelegramHeading: "Telegram",
  profileTelegramConnected: "Ulangan",
  profileTelegramNotConnected: "Ulanmagan",
  profileTelegramConnect: "Telegram akkauntini ulash",
  profileTelegramDisconnect: "Uzish",
  profileTelegramDisconnectTitle: "Telegram akkauntini uzish?",
  profileTelegramDisconnectBody: "Shundan keyin Telegram orqali kirish ishlamaydi.",
  profileTelegramConnectedDone: "Telegram akkaunti ulandi.",
  profileTelegramDisconnectedDone: "Telegram akkaunti uzildi.",
  profileTelegramLoadFailed: "Telegram holatini yuklab bo'lmadi.",
  profileTelegramUnavailable: "Telegram ulanishi hozircha sozlanmagan.",
  profilePasswordHeading: "Parol",
  profileCurrentPassword: "Joriy parol",
  profileNewPassword: "Yangi parol",
  profileRepeatPassword: "Yangi parolni takrorlang",
  profilePasswordSubmit: "Parolni yangilash",
  profilePasswordDone: "Parol yangilandi.",
  profileRetry: "Qayta urinish",

  passwordTooShort: "Parol kamida 8 belgidan iborat bo'lishi kerak",
  passwordMismatch: "Parollar mos kelmadi",
  genericError: "Xatolik yuz berdi. Qayta urinib ko'ring.",
} as const;

export type AuthMessageKey = keyof typeof AUTH_MESSAGES;
